<template>
  <i
    :class="`fa ${iconType} fa-${dasherize(icon)} ${active ? ('active ' + activeClass) : ''}`"
    @click="toggle"
  >
  </i>
</template>

<script>
import { dasherize } from '../../../libs/strings';

export default {
  props: {
    modelValue: { type: String, required: false, default: null },
    checkedValue: { type: String, required: true },
    uncheckedValue: { type: String, required: false, default: null },
    icon: { type: String, required: true },
    iconType: { type: String, required: false, default: 'far' },
    activeClass: { type: String, required: false, default: 'text-success' },
  },
  computed: {
    active() {
      return this.modelValue === this.checkedValue;
    },
  },
  methods: {
    dasherize,
    toggle() {
      if (!this.active) {
        this.$emit('update:modelValue', this.checkedValue);
      } else {
        this.$emit('update:modelValue', this.uncheckedValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../assets/stylesheets/cifra/vars/main.scss";

  i {
    cursor: pointer;
  }

  i:not(.active):before {
    color: $gris-disabled;
  }
</style>
